/** Header names and Cloudflare geo field keys the request-metadata collector copies into the activity / trigger metadata blob -- the specific subset that path consumes, not the standard header-NAME catalog.
 *
 * IT OWNS THESE NAMES OUTRIGHT, not just for the collector: `const/flow-run-trigger.ts` carried its own
 * CF_IP_COUNTRY_HEADER = 'cf-ipcountry' spelling -- un-backticked, since the fold removed it and the name resolves
 * nowhere -- until 2026-08-22, so the telemetry ingest worker and the trigger geo
 * resolver read the SAME wire header through two unrelated constants. A `cf-*` or forwarded-identity header name gets
 * a member here and is read from here; it never gets a second home. */

export const REQUEST_METADATA_HEADERS = {
	CF_CONNECTING_IP: 'cf-connecting-ip',
	X_FORWARDED_FOR: 'x-forwarded-for',
	X_REAL_IP: 'x-real-ip',
	USER_AGENT: 'user-agent',
	CF_VERIFIED_BOT: 'cf-verified-bot',
	CF_IP_COUNTRY: 'cf-ipcountry',
	CF_IP_CITY: 'cf-ipcity',
	ORIGIN: 'origin',
} as const;

/**
 * The forwarded headers whose values are PLACE NAMES, and therefore routinely non-ASCII.
 *
 * Cloudflare sets these from its geo database, so accented place names -- Montreal, Durres County, Sao Paulo, Moradabad, each carrying codepoints above U+007F -- are ordinary
 * values -- and copying one onto an outbound `Headers` makes the runtime warn that a browser would throw a TypeError
 * on it. Consumers pass each through `encodeAsciiHeaderValue` (`utils/http/ascii-header-value.ts`).
 *
 * `cf-ipcountry` is NOT here: it is a two-letter ISO code and cannot be non-ASCII.
 */
export const NON_ASCII_PRONE_GEO_HEADERS = Object.freeze(['cf-ipcity', 'cf-region']);

/** A raw cf-object copy, no coercion or fallback, and the ONLY such list: there is no coercing sibling, and the
 *  `RunTrigger` envelope carries colo + country only -- never a city, postal code or coordinates. This list stands on
 *  its own consumers. */
export const GEO_KEYS = Object.freeze([
	'country',
	'region',
	'regionCode',
	'city',
	'postalCode',
	'latitude',
	'longitude',
	'timezone',
] as const);
